import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { userSchema } from "../user";

export const creditScoringATSSchema = z.object({
  id: z.string(),
  quantity: z.number(),
  remain: z.number(),
  souscriptionId: z.string().optional().nullable(),
  userId: z.string(),
  user: userSchema.optional(),
  updatedAt: z.coerce.date(),
});

export class CreditScoringATSDto extends createZodDto(creditScoringATSSchema) {}
